module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAAc0lEQVQYV3XPMQ5BURAF0DMLUCgtyiIEYQNWoKHEWohKqNiEEJVdjDx5kld8057M3DuRmUe8sYyIuzqRmTsMccAqIl7FCgwwwRinuvmIopnZx7ziBZsvVOxhhgVu/+DadeqM7S98ilET/mzr7rFu63Y++AHlJDe8EznhQgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/downHoverIcon.png
// module id = 4Dt0
// module chunks = 2